<template>
	<div class="stage score-screen" :class="blocks[currentBlock].settings.score.template" :style="{ 'background-image': backgroundImage }">

		<div class="background-overlay score-screen__background-overlay">

			<div class="content-container">

				<HeaderBlock :header="stageData.header" :subHeader="stageData.subheader" :bodytext="stageData.feedback" />

				<div v-if="visualExists" class="centered" style="position: relative">
					<img
							:src="baseUrl + stageData.visual"
							class="visual"
					/>
				</div>

				<div class="totem" v-if="blocks[currentBlock].settings.score.template == 'Bars'">

					<div class="totemRow" v-for="(score,index) in totem.visuals" :class="totem.types[totem.visuals.length-1-index]+' row_'+index">


							<div class="totemRow__item" v-if="totem.types[totem.types.length-1-index]!=='SDG'">
			                    <div class="totemRow__item--holder">
								   <img :src="baseUrl + totem.visuals[totem.visuals.length-1-index]"/>
			                    </div>
							</div>
							<div class="totemRow__item-text" v-if="totem.types[totem.types.length-1-index]!=='SDG'">
								<div class="positioner" v-if="totem.scores[totem.visuals.length-1-index] >= 0">
									<h5>{{totem.labels[totem.visuals.length-1-index]}}</h5>
									<p>{{totem.scores[totem.visuals.length-1-index]}}/100</p>
			                        <div class="progress-bar">
			                            <div class="progress-bar__length" :style="{ 'width': totem.scores[totem.visuals.length-1-index] + '%' }"></div>
			                        </div>
								</div>
								<div class="positioner disabled" v-else>
									<h5>{{totem.labels[totem.visuals.length-1-index]}}</h5>
								</div>
							</div>


							<div class="totemRow__item" v-if="totem.types[totem.types.length-1-index]==='SDG'">
								
			                    <div class="totemRow__item--holder">
								   <img :src="baseUrl + totem.visuals[totem.visuals.length-1-index]"/>
			                    </div>

			                </div>
			                <div class="totemRow__item-text" v-if="totem.types[totem.types.length-1-index]==='SDG'">

			                	<div class="positioner disabled" v-if="totem.sdgs[totem.visuals.length-1-index].sdgCount.length == 0">
									<h5>{{totem.labels[totem.visuals.length-1-index]}}</h5>
								</div>
								<div class="positioner" v-else>
									<h5>{{totem.labels[totem.visuals.length-1-index]}} : {{typeLabels[totem.sdgs[totem.visuals.length-1-index].bestCluster]}}</h5>
								</div>

			                    <!-- <div class="sdgs" v-for="(sdgCount,sdgIndex) in totem.sdgs[totem.visuals.length-1-index].sdgCount">

			                    	<div class="sdg--holder">
			                    		{{sdgIndex}} -> {{sdgCount}}
			                    	</div>

			                    </div> -->

							</div>

					</div>
					<div class="totemRow totemRow-impactScore" v-if="userImpact"><div class="earthHoder earths_visual"></div></div>

				</div>




				<div class="totem" v-else-if="blocks[currentBlock].settings.score.template == 'Dashboard'">

					<div class="totemContainer">
						<div class="totemItem" v-for="(score,index) in totem.visuals">
							<div class="totemItem__item">
			                    <div class="totemItem__item--holder">
								   <img :src="baseUrl + totem.visuals[totem.visuals.length-1-index]"/>
			                    </div>
							</div>
						</div>

						<div class="totemLabel" :class="'pos_'+index" v-for="(score,index) in totem.visuals">
							<div class="totemLabel__item-text">
								<div class="positioner" v-if="totem.scores[totem.visuals.length-1-index] >= 0">
									<p>{{totem.labels[totem.visuals.length-1-index]}}: {{totem.scores[totem.visuals.length-1-index]}}%</p>
								</div>
							</div>
						</div>
					</div>

					<div class="text" style="position: relative">
						{{stageData.feedback}}
					</div>
					<div class="totemRow totemRow-impactScore" v-if="userImpact"><div class="earthHoder earths_visual"></div></div>

				</div>
				




				<div class="totem" v-else-if="blocks[currentBlock].settings.score.template == 'Ladder'">
					<div class="totemRow" v-for="(score,index) in totem.visuals">
						<div class="totemRow__item">
		                    <div class="totemRow__item--holder">
							   <img :src="baseUrl + totem.visuals[totem.visuals.length-1-index]"/>
		                    </div>
						</div>
						<div class="totemRow__item-text" :class="'pos_'+index">
							<div class="positioner" v-if="totem.scores[totem.visuals.length-1-index] >= 0">
								<h5>{{totem.labels[totem.visuals.length-1-index]}}</h5>
								<p>{{totem.scores[totem.visuals.length-1-index]}}%</p>
							</div>
						</div>
					</div>
					<div class="totemRow totemRow-impactScore" v-if="userImpact"><div class="earthHoder earths_visual"></div></div>
				</div>


				<div class="totem" v-else>
					<div class="totemRow" v-for="(score,index) in totem.visuals">
						<div class="totemRow__item">
		                    <div class="totemRow__item--holder">
							   <img :src="baseUrl + totem.visuals[totem.visuals.length-1-index]"/>
		                    </div>
						</div>
						<div class="totemRow__item-text" :class="'pos_'+index">
							<div class="positioner" v-if="totem.scores[totem.visuals.length-1-index] >= 0">
								<h5>{{totem.labels[totem.visuals.length-1-index]}}</h5>
								<p>{{totem.scores[totem.visuals.length-1-index]}}/100</p>
							</div>
						</div>
					</div>
					<div class="totemRow totemRow-impactScore" v-if="userImpact"><div class="earthHoder earths_visual"></div></div>
				</div>
			
			</div>

		</div>
	</div>

</template>

<script>

	import HeaderBlock from './HeaderBlock.vue';
	import { url} from '../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {
		components:{
			HeaderBlock
		},

		props:[
			'text',
			'visual',
		],

		beforeMount(){
			this.setTotem();
		},

		mounted(){

			console.log('userImpact: '+this.userImpact);

			if(this.lastBlock){
				//console.log('last block!!!');
			}else{
				setTimeout(()=>{
					this.setNextButtonAction(this.stopBlockTransition).then(()=> {
						this.showNextButton();
					});
				},500);
			}
			if (this.userImpact) {
				var wholeEarths = Math.floor(this.userImpact);
	            var partlyEarth = this.userImpact - wholeEarths;

	            for (var i = 0; i < wholeEarths; i++) {
	                $('.earths_visual').append('<img class="whole-earth" src="'+this.baseUrl+'media/rws_impact/earth_red.svg">');
	            };

	            if(partlyEarth > 0.4){
	                $('.earths_visual').append('<img class="half-earth" src="'+this.baseUrl+'media/rws_impact/half_earth_red.svg">');
	            }
	        }
		},

		data(){
			return {
				baseUrl : url,
				totem: {},
				sdgClusters:{economy:[8,9,10,12], society:[1,2,3,4,5,7,11,16], biosphere:[6,13,14,15]},
				typeLabels: {economy:'Economie',society:'Mens',biosphere:'Milieu'},
			}
		},
		methods:{

			getScoreFromBlockIndex(index){

				let score = 0;
				let rounds = 0;
				let block = this.blocks[index];



				for(let i = 0 ; i < block.data_structure.length ; i++){
					let stage = block.data_structure[i];


					if(stage.type != "Rounds") continue;


					for(let j = 0 ; j < stage.data.rounds.length ; j++){

						let round = stage.data.rounds[j];

						// console.log(round);

						if(round.score !== undefined && round.questions.usescore === "Yes"){
							rounds ++;
							score += round.score;
						}
					}
				}

				// console.log('getScoreFromBlockIndex');
				// console.log(score);
				// console.log(rounds);
				
				return Math.round(score/rounds);
			},

			getSdgCountFromBlockIndex(index){

				let rounds = 0;
				let block = this.blocks[index];

				let sdgObject = {};

				sdgObject.sdgCount = [];


				for(let i = 0 ; i < block.data_structure.length ; i++){
					let stage = block.data_structure[i];


					if(stage.type != "Rounds") continue;


					for(let j = 0 ; j < stage.data.rounds.length ; j++){

						let round = stage.data.rounds[j];

						console.log('round: ');
						console.log(round);

						if(typeof round.sdgs !== 'undefined' && round.questions.usescore === "Yes"){
							
							
							for (var l = 0; l < round.sdgs.length; l++) {
								
								let sdgIndex = round.sdgs[l];

								console.log('sdgIndex: '+sdgIndex);

								if(typeof sdgObject.sdgCount[sdgIndex] === 'undefined'){

									sdgObject.sdgCount[sdgIndex] = 1;

								}else{
									sdgObject.sdgCount[sdgIndex] += 1;
								}

							}

						}
					}
				}


				//sdgClusters
				sdgObject.clusters = {};
				for (let property in this.sdgClusters)
				{
					if (this.sdgClusters.hasOwnProperty(property)){

						let cluster = this.sdgClusters[property];
						let clusterCount = 0;

						for(let j = 0 ; j < cluster.length; j++){
							if(sdgObject.sdgCount[cluster[j]] > 0){
								clusterCount += sdgObject.sdgCount[cluster[j]];
							}
						}

						sdgObject.clusters[property] = clusterCount;
					}

				};

				let bestScoredCluster = 0;
				let cluster = '';
				for (let property in sdgObject.clusters)
				{
					if (sdgObject.clusters.hasOwnProperty(property)){

						if(sdgObject.clusters[property] > bestScoredCluster){
							bestScoredCluster = sdgObject.clusters[property]

							cluster = property;
						}
					}
				}

				sdgObject.bestCluster = cluster;


				console.log('getSdgCountFromBlockIndex');
				console.log(sdgObject.sdgCount);
				console.log(sdgObject.clusters);
				console.log(sdgObject.bestCluster);
				
				return sdgObject;
			},


			setTotem(){

				let visuals = [];
				let scores = [];
				let labels = [];
				let types = [];
				let sdgs = [];

				// for(let i = 0 ; i <this.blocks.length  ; i++){

				for(let i = this.blocks.length-1 ; i >= 0  ; i--){

					let block = this.blocks[i];

					let settings = block.settings;
					if(settings == null || settings.score == null || settings.score.use == null || settings.score.use != "Yes") continue;


					types.push(settings.score.label);

					sdgs.push(this.getSdgCountFromBlockIndex(i));

					//console.log(block.type);

					if(typeof settings.score.displaylabel !== 'undefined'){
						labels.push(settings.score.displaylabel == null ? "Not defined" : settings.score.displaylabel);
					}else{
						labels.push(settings.score.label == null ? "Not defined" : settings.score.label);
					}
					
					

					if(this.currentBlock < i){


							visuals.push(settings.score.visual_off_state);
							scores.push(-1);

					}
					else{

						if(this.blocks[this.currentBlock].settings.score.template == 'Ladder'){

							if(this.currentBlock == i){

								visuals.push(settings.score.visual_on_state);

							}else{

								visuals.push(settings.score.visual_off_state);
								
							}

						}else{

							visuals.push(settings.score.visual_on_state);
						}

						
						scores.push(this.getScoreFromBlockIndex(i));

					}
				}

				if(this.blocks[this.currentBlock].settings.score.template == 'Ladder' || this.blocks[this.currentBlock].settings.score.template == 'Totem'){ // || 
					visuals.reverse();
					scores.reverse();
					labels.reverse();
					types.reverse();
					sdgs.reverse();
				}

				this.totem = {
					visuals: visuals,
					scores : scores,
					labels : labels,
					types : types,
					sdgs : sdgs,
				}
			},


			...mapActions([
				'setNextButtonAction',
				'showNextButton',
				'stopBlockTransition',

			]),
		},
		computed:{
			...mapGetters([
				"roundData",
				"stageData",
				'currentBlock',
				'lastBlock',
				'blocks',
				'userImpact',
			]),

			visualExists(){
				return this.stageData != null && this.stageData.visual != null;
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },
		},

	}
</script>



// WEBPACK FOOTER //
// src/components/minigames/Totem.vue